var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"living-options-properties"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"properties"},[_c('h3',[_vm._v("Properties")]),_c('button',{staticClass:"btn btn-sm btn-primary mb-4",on:{"click":_vm.addProperty}},[_vm._v("\n          Add Property\n        ")]),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-6"},[_c('label',{attrs:{"for":"filterRelease"}},[_vm._v("Filter By Release:")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterReleaseId),expression:"filterReleaseId"}],attrs:{"name":"filterRelease"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterReleaseId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.subsections),function(subsection){return _c('option',{domProps:{"value":subsection.id}},[_vm._v("\n                "+_vm._s(subsection.label)+"\n              ")])}),0)]),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"status-option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterActiveStates),expression:"filterActiveStates"}],attrs:{"type":"checkbox","id":"active","value":"Active"},domProps:{"checked":Array.isArray(_vm.filterActiveStates)?_vm._i(_vm.filterActiveStates,"Active")>-1:(_vm.filterActiveStates)},on:{"change":function($event){var $$a=_vm.filterActiveStates,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="Active",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterActiveStates=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterActiveStates=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterActiveStates=$$c}}}}),_c('label',{staticClass:"status-option__label",attrs:{"for":"active"}},[_vm._v("Active")])]),_c('div',{staticClass:"status-option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterActiveStates),expression:"filterActiveStates"}],attrs:{"type":"checkbox","id":"inactive","value":"Inactive"},domProps:{"checked":Array.isArray(_vm.filterActiveStates)?_vm._i(_vm.filterActiveStates,"Inactive")>-1:(_vm.filterActiveStates)},on:{"change":function($event){var $$a=_vm.filterActiveStates,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="Inactive",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterActiveStates=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterActiveStates=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterActiveStates=$$c}}}}),_c('label',{staticClass:"status-option__label",attrs:{"for":"inactive"}},[_vm._v("Inactive")])])])]),_c('div',{staticClass:"mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propertiesFilterText),expression:"propertiesFilterText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Filter properties"},domProps:{"value":(_vm.propertiesFilterText)},on:{"input":function($event){if($event.target.composing)return;_vm.propertiesFilterText=$event.target.value}}})]),_c('v-table',{attrs:{"columns":[
            {
              label: 'Label',
              field: 'label',
            },
            {
              label: 'Status',
              field: 'status',
              options: {
                sortable: true,
                callback: function (row) {
                  _vm.filterByStatus(row);
                },
                return: function (fieldValue) {
                  if (fieldValue === 'Not Found') {
                    return '-';
                  } else {
                    switch (fieldValue) {
                      case 'Available':
                        return `<div class='status status--available'>${fieldValue}</div>`;

                      case 'Coming Soon':
                        return `<div class='status status--coming-soon'>${fieldValue}</div>`;

                      case 'On Hold':
                        return `<div class='status status--hold'>${fieldValue}</div>`;

                      case 'Sold':
                        return `<div class='status status--sold'>${fieldValue}</div>`;

                      case 'Builder Lots':
                        return `<div class='status status--builder-lots'>${fieldValue}</div>`;

                      case 'Not Released':
                        return `<div class='status status--not-released'>${fieldValue}</div>`;

                      default:
                        return fieldValue;
                    }
                  }
                },
              },
            },
            {
              label: 'Price',
              field: 'price',
              options: {
                sortable: true,
                return: function (fieldValue) {
                  if (fieldValue === 'Not Found' || !fieldValue) {
                    return '-';
                  } else {
                    return fieldValue.toLocaleString('en-AU', {
                      style: 'currency',
                      currency: 'AUD',
                      maximumSignificantDigits: 10,
                    });
                  }
                },
              },
            },

            {
              label: 'Subsection',
              field: 'subsection.label',
              options: {
                sortable: true,
                callback: function (row) {
                  _vm.navToSubsection(row);
                },
                return: function (fieldValue) {
                  if (fieldValue === 'Not Found') {
                    return '-';
                  } else {
                    return fieldValue;
                  }
                },
              },
            },
            {
              label: 'Living Option',
              field: 'livingOption.label',
              options: {
                sortable: true,
                callback: function (row) {
                  _vm.navToLivingOption(row);
                },
                return: function (fieldValue) {
                  if (fieldValue === 'Not Found') {
                    return '-';
                  } else {
                    return fieldValue;
                  }
                },
              },
            },
            {
              label: 'Dwelling',
              field: 'dwelling.label',
              options: {
                sortable: true,
                callback: function (row) {
                  _vm.navToDwelling(row);
                },
                return: function (fieldValue) {
                  if (fieldValue === 'Not Found') {
                    return '-';
                  } else {
                    return fieldValue;
                  }
                },
              },
            },
            {
              label: 'Link',
              field: '_id',
              options: {
                sortable: false,
                return: function (fieldValue) {
                  return `<a class='table-link' href='/live/properties/${fieldValue}' target='_blank'>Link</a>`;
                },
              },
            },
          ],"rows":_vm.filteredProperties,"show-active-toggle":_vm.activeUser.access.indexOf('live-toggle') !== -1,"save-action":"SAVE_PROPERTY"},on:{"edit":function($event){return _vm.editProperty($event._id)},"clone":function($event){return _vm.cloneProperty($event)},"delete":function($event){return _vm.deleteProperty($event._id)}}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }